import React from "react";

const CardLabel = (props: {title: string}) => {
    return <h3 className="text-base font-medium text-gray-900">{props.title}</h3>;
};

export default CardLabel;
